<template>
    <el-dialog
        class="editmystore"
        :visible.sync="mystoreVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="Store list"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="demo-input-suffix" style="padding:0 0 10px 0"> 
            <el-input v-model="name" clearable placeholder="Please input store name" style="width:80%" @input="myStoreList"></el-input>
            <stores
                style="display: inline"
                :platformList="platformList"
                :tableItem="tableItem"
                placement="bottom"
            >
                <el-button type="primary" style="float:right">New Store</el-button>
            </stores>
            
         </div>
        <el-table
                :data="tableData"
                highlight-current-row
                height="calc(100% - 96px)"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    label="Store Name"
                    property="name"
                    align="left"
                    min-width="150"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('storeList.tableName.platform_id')"
                    property="platform_name"
                    align="left"
                    min-width="120"
                ></el-table-column>
                <el-table-column
                    :label="$t('storeList.tableName.open_date')"
                    property="open_date"
                    align="left"
                ></el-table-column>
                <el-table-column
                    :label="$t('storeList.add.language')"
                    property="lang"
                    align="left"
                ></el-table-column>
                <el-table-column
                    :label="$t('storeList.tableName.customized')"
                    property="customized"
                    align="center"
                >
                    <template slot-scope="scoped">
                        <i
                            class="col-customized"
                            :class="[
                                scoped.row.customized == 1
                                    ? 'el-icon-circle-check check'
                                    : 'el-icon-circle-close',
                            ]"
                        ></i>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('storeList.tableName.authed_success')"
                    align="center"
                    min-width="100"
                >
                    <template slot-scope="scoped">
                        <i
                            class="col-customized"
                            :class="[
                                scoped.row.authed == 1
                                    ? 'el-icon-circle-check check'
                                    : 'el-icon-circle-close',
                            ]"
                        ></i>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Status"
                    property="status"
                    align="center"
                >
                    <template slot-scope="scoped">
                        <i
                            class="col-customized"
                            :class="[
                                scoped.row.status == 1
                                    ? 'el-icon-circle-check check'
                                    : 'el-icon-circle-close',
                            ]"
                        ></i>
                    </template>
                </el-table-column>
                
                <el-table-column
                    :label="$t('storeList.tableName.operation')"
                    align="center"
                    width="150"
                    :fixed="operationFixed"
                >
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="edit(scope.row)">edit</el-button>
                    </template>

                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
            <edit
                :editVisible.sync="editVisible"
                :tableItem.sync="tableItem"
            ></edit>
            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
                :funcName="funcName"
            ></pagination>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
// import stores from "@/common/components/stores.vue";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import edit  from "@/views/pages/storePlatform/storeList/edit";
import stores from "@/common/components/stores";
import { mapActions } from "vuex";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            name:"",
            loading:false,
            editVisible: false,
            tableData:[
            ]
        };
    },
    methods: {
        myStoreList(page,uid) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .myStore(
                    {
                        ...this.paginationData,
                        user_id: uid ? uid : this.tableItem.id,
                        name: this.name,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.loading = false;

                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        edit(row) {
            this.editVisible = true;
            this.tableItem = row;
        },
        closeDialog() {
            //this.$refs["editForm"].clearValidate();
            //this.$refs["editForm"].resetFields();
            this.$emit("update:mystoreVisible", false);
        },

        async initialize() {
            this.myStoreList();
        },
    },

    components: {
    edit,
    stores,
},
    props: {
        mystoreVisible: Boolean,
        tableItem:Object,
        platformList:Object
    },
    watch: {
        mystoreVisible:{
            handler: function(nv, ov) {
                if (nv) {
                    this.initialize();
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.editmystore {
    ::v-deep .el-dialog {
        height: 80vh;

        .el-table {
            .col-customized {
                font-size: 18px;
                &.check {
                    color: $color-primary;
                }
            }
        }
    }
}
</style>
